var _a;
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import { parkingSplitApi } from './api';
import { authUserReducer, vehicleDetailsReducer, ownerReducer, vehicleRegisterErrorReducer, carpoolReducer, registerformStateReducer, vehicleRegistrationReducer, environmentReducer, configReducer, chaufferReducer, regionReducer, } from './slices';
import { carpoolErrorReducer } from './slices/carpoolError';
import { infoBadgeStateReducer } from './slices/infoBadge';
var reducer = (_a = {
        environment: environmentReducer,
        user: authUserReducer,
        formState: registerformStateReducer,
        ownerDetails: ownerReducer,
        vehicleDetails: vehicleDetailsReducer,
        registerVehicleError: vehicleRegisterErrorReducer,
        carpool: carpoolReducer,
        isCarpoolError: carpoolErrorReducer,
        infoBadge: infoBadgeStateReducer,
        config: configReducer,
        vehicleRegistration: vehicleRegistrationReducer
    },
    _a[parkingSplitApi.reducerPath] = parkingSplitApi.reducer,
    _a.chauffer = chaufferReducer,
    _a.regionConfig = regionReducer,
    _a);
export var store = configureStore({
    reducer: reducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: function (getDefaultMiddleware) { return getDefaultMiddleware().concat(parkingSplitApi.middleware); },
});
setupListeners(store.dispatch);
